const defaults = {
    labels: {
        ActiveIngredients: 'Active Ingredients',
        AddToCart: 'Add To Cart',
        By: 'By',
        Decrement: 'Decrement',
        DevelopedFor: 'Developed For',
        FavoriteSrText: 'Add to Favorites',
        HowTo: 'How-to',
        Increment: 'Increment',
        LoaderSrText: 'Loading...',
        LoginDescription: 'Lorem ipsum dolor sit amet.',
        Login: 'Log In',
        OneTimePurchase: 'One-time Purchase',
        PleaseSelect: 'Please Select',
        ProductInformation: 'Product Information',
        Quantity: 'Quantity',
        QuantitySelector: 'Quantity selector',
        RxText: '<strong>*Prescription Required:</strong> Vetsource, our pharmacy provider may need to contract your veterinary hospital for prescription verification.',
        Save: 'Save',
        Subscribe: 'Subscribe & Never Forget',
        SuccessMessage: '{0} was added to your cart',
        UsageGuidelines: 'Usage Guidelines',
        YourPrice: 'Your Price',
        ZoomSrText: 'Zoom in image'
    }
};

export {
    defaults
};
